const env = {
  QUESTIONNAIRE_API_URL: process.env.REACT_APP_QUESTIONNAIRE_API_URL,
  LAUNCHDARKLY_ID: process.env.REACT_APP_LAUNCHDARKLY_ID,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  ACE_API_URL: process.env.REACT_APP_ACE_API_URL,
  NEW_MEMBER_API_URL: process.env.REACT_APP_NEW_MEMBER_API_URL,
  WELCOME_HEADER_IMAGE_MOBILE: process.env.REACT_APP_WELCOME_HEADER_IMAGE_MOBILE,
  WELCOME_HEADER_IMAGE_DESKTOP: process.env.REACT_APP_WELCOME_HEADER_IMAGE_DESKTOP,
  COOKIE_DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN,
  REACT_APP_GTM_CONTAINER_ID: process.env.REACT_APP_GTM_CONTAINER_ID,
  BOX_API_URL: process.env.REACT_APP_BOX_API_URL,
  UNIVERSAL_NAV_API_URL: process.env.REACT_APP_UNIVERSAL_NAV_API_URL,
  DATADOG_RUM_APP_ID: process.env.REACT_APP_DATADOG_RUM_APP_ID,
  DATADOG_RUM_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
  CHATBOT_AGENT_ID: process.env.REACT_APP_APPLIED_LABS_AGENT_ID,
};

export default env;
